
import Vue from 'vue';
import {
  AlignHorizontalLeft16,
  AlignHorizontalCenter16,
  AlignHorizontalRight16,
  AlignVerticalTop16,
  AlignVerticalCenter16,
  AlignVerticalBottom16,
} from '@carbon/icons-vue';
import { CvIconButton } from '@carbon/vue';
import { mapActions, mapState } from 'pinia';
import { Category, PmsColor } from '@midocean/webapps-shared-domain';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useNotificationStore } from '@/stores/v2/notification';
import { useStore as useHistoryStore } from '@/stores/v2/history';
import { useStore as useMirrorStore } from '@/stores/v2/mirror';
import { updateTargetLines } from '@/utils/roundItemsHelper';
import { generateEventPayloadV2 } from '@/utils/generatePriceParamsEventPayload';
import { createStateSnapshot } from '@/utils/historyHelperV2';
import { lineWidthV2 } from '@/constants/areaLineWidth';
import { BACKGROUND_IMAGE_W } from '@/web-components/import-wizard-v2/constants';
import { isAlignButtonDisabled } from '@/utils/alignmentHelper';

export default Vue.extend({
  name: 'AlignShapeControls',
  components: {
    AlignHorizontalLeft16,
    AlignHorizontalCenter16,
    AlignHorizontalRight16,
    AlignVerticalTop16,
    AlignVerticalCenter16,
    AlignVerticalBottom16,
    CvIconButton,
  },

  data() {
    return {
      attributes: {
        logoAlign: '',
        colorName: '',
        color: {} as PmsColor,
      },
    };
  },

  computed: {
    ...mapState(useShapeStore, ['shapes', 'activeShapeId', 'shapeById']),
    ...mapState(useProductStore, [
      'activePosition',
      'panelPosition',
      'panelsPositions',
      'centerCoordinatesOfPanels',
      'isSublimationTechnique',
    ]),
  },

  methods: {
    ...mapActions(useShapeStore, [
      'alignRoundItemShape',
      'alignShape',
      'checkIsShapeInArea',
      'applySublimationConverter',
    ]),
    ...mapActions(useNotificationStore, ['runValidators']),
    ...mapActions(useMirrorStore, ['updateMirrorShape']),
    ...mapActions(useHistoryStore, ['recordHistory']),
    ...mapActions(useProductStore, ['printPositionArea']),
    isAlignButtonDisabled,

    generateId(icon: string) {
      if (icon === 'align-horizontal-left') {
        return 'align-left';
      }
      if (icon === 'align-horizontal-center') {
        return 'align-center-h';
      }
      if (icon === 'align-horizontal-right') {
        return 'align-right';
      }
      if (icon === 'align-vertical-top') {
        return 'align-top';
      }
      if (icon === 'align-vertical-center') {
        return 'align-center-v';
      }
      if (icon === 'align-vertical-bottom') {
        return 'align-bottom';
      }
    },

    alignLogo(alignmentType: string) {
      this.attributes.logoAlign = alignmentType;
      if (this.activePosition.category === Category.RoundItem) {
        this.alignRoundItemShape(
          this.activeShapeId,
          this.panelPosition,
          alignmentType
        );
        const shape = this.shapes.find((s) => s.id === this.activeShapeId);
        if (shape !== undefined) {
          updateTargetLines(
            shape,
            this.centerCoordinatesOfPanels,
            this.panelsPositions
          );
        }
      } else {
        this.alignShape(this.activeShapeId, alignmentType);
      }

      this.checkIsShapeInArea(this.activeShapeId);
      this.runValidators();

      const activeShape = this.shapeById(this.activeShapeId);
      if (this.isSublimationTechnique && activeShape && activeShape.isInArea) {
        this.applySublimationConverter(this.activeShapeId);
      }

      if (activeShape) {
        this.updateMirrorShape(activeShape);
      }

      const eventPayload = generateEventPayloadV2();

      this.$emit('wizard:price-params-changed', {
        productPrintPositions: eventPayload,
      });

      const snapshot = createStateSnapshot();
      this.recordHistory(snapshot);
    },
  },
});
